import { path, includes } from 'ramda'

/**
 * Actions.
 *
 * @param {FetchPath} fetchPath
 * @return {Object}
 */
export default ({ fetchPath }) => ({
  /**
   * Loads notifications from the server.
   *
   * @param {Function} commit
   * @return {Promise}
   */
  async xhrLoad({ commit }) {
    const result = await fetchPath.run(
      {
        method: 'GET',
        path: '/yoda/api/notifications',
        parameters: {
          itemsPerPage: 99,
          'order[created]': 'desc',
        },
      },
    )

    const entities = path(['content', 'data'], result)

    await commit('REPLACE_ENTITIES', { entities })
    await commit('SET_LOADED', { loaded: true })

    return entities
  },

  /**
   * Reports that a notification has been viewed to the server.
   *
   * @param {Object} state
   * @param {Function} commit
   * @param {Object} notification
   * @return {Promise}
   */
  async xhrMarkAsViewed({ state, commit }, { notification }) {
    const entityId = path(['attributes', 'id'], notification)

    if (includes(entityId, state.viewedEntityIds)) {
      return
    }

    await fetchPath.run(
      {
        method: 'PUT',
        path: `/yoda${notification.id}/viewed`,
      },
    )

    commit('ADD_VIEWED_ENTITY_ID', { entityId })
  },

  /**
   * Issues a request to delete a notification.
   *
   * @param {Function} commit
   * @param {Object} notification
   * @returns {Promise<void>}
   */
  async xhrDelete({ commit }, { notification }) {
    commit('REMOVE_ENTITY', { entity: notification })
    await fetchPath.run(
      {
        method: 'DELETE',
        path: `/yoda${notification.id}`,
      },
    )
  },
})
